import UserPermissionTypes from '@constants/permissions';
import { filterAddMemberTabs } from '@features/group-management/helpers/addMemberTabPermissions';
import { TabPill } from 'types/tabs';

/** Branch QC entry: payment_order_create && (branch_member_view || branch_member_create) */
export const BRANCH_QUICK_COLLECT_MEMBER_PERMISSIONS: string[] = [
  UserPermissionTypes.BRANCH_MEMBER_VIEW,
  UserPermissionTypes.BRANCH_MEMBER_CREATE
];

/**
 * Group QC entry: payment_order_create &&
 * (group_member_view || group_member_create || branch_member_view)
 */
export const GROUP_QUICK_COLLECT_MEMBER_PERMISSIONS: string[] = [
  UserPermissionTypes.GROUP_MEMBER_VIEW,
  UserPermissionTypes.GROUP_MEMBER_CREATE,
  UserPermissionTypes.BRANCH_MEMBER_VIEW
];

const hasPermission = (
  userPermissions: string[] | undefined,
  permission: string
): boolean => !!userPermissions?.includes(permission);

const hasAnyPermission = (
  userPermissions: string[] | undefined,
  permissions: string[]
): boolean =>
  permissions.some((permission) => hasPermission(userPermissions, permission));

export const canAccessBranchQuickCollect = (
  userPermissions: string[] | undefined
): boolean =>
  hasPermission(userPermissions, UserPermissionTypes.PAYMENT_ORDER_CREATE) &&
  hasAnyPermission(userPermissions, BRANCH_QUICK_COLLECT_MEMBER_PERMISSIONS);

export const canAccessGroupQuickCollect = (
  userPermissions: string[] | undefined
): boolean =>
  hasPermission(userPermissions, UserPermissionTypes.PAYMENT_ORDER_CREATE) &&
  hasAnyPermission(userPermissions, GROUP_QUICK_COLLECT_MEMBER_PERMISSIONS);

/** QC add-payer tabs — reuses shared add-member tab gates. */
export const filterQuickCollectAddMemberTabs = (
  tabs: TabPill[],
  userPermissions: string[] | undefined,
  isGroupQuickCollect: boolean
): TabPill[] => filterAddMemberTabs(tabs, userPermissions, isGroupQuickCollect);
